var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8928 0.692796C12.2833 0.302271 12.9165 0.302271 13.307 0.692796C13.6975 1.08332 13.6975 1.71648 13.307 2.10701L8.41412 6.9999L13.307 11.8928C13.6975 12.2833 13.6975 12.9165 13.307 13.307C12.9165 13.6975 12.2833 13.6975 11.8928 13.307L6.9999 8.41412L2.10701 13.307C1.71649 13.6975 1.08332 13.6975 0.692796 13.307C0.302271 12.9165 0.302271 12.2833 0.692796 11.8928L5.58569 6.9999L0.692796 2.10701C0.302271 1.71648 0.302271 1.08332 0.692796 0.692796C1.08332 0.302271 1.71649 0.302271 2.10701 0.692796L6.9999 5.58569L11.8928 0.692796Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.2e83bab5.svg";
export { ForwardRef as ReactComponent };